<div class="notification-table-container">
  @if (tableVisible) {
  <owc-table #tableEl [style.--body-grid-template-columns]="bodyGridTemplateColumns">
    @if(isApiLoading){
    <div class="spinner-overlay">
      <owc-progress-spinner size="xxLarge" value="50" />
    </div>
    }
  <owc-table-header sticky>
    <owc-table-header-cell vertical-border="true" [verticalBorder]="true" resizable [width]="columnWidths['Type'] + 'px'" sortable [align]="'left'" (sortOrderChange)="OnSort('Type', $event.detail)" (widthChange)="onColumnWidthChange('Type', $event)">
      <div class="header-cell-content">
        <span>Type</span>
      </div>
    </owc-table-header-cell>
    <owc-table-header-cell vertical-border="true" [verticalBorder]="true" resizable [width]="columnWidths['GlobalId'] + 'px'" sortable [align]="'left'" (sortOrderChange)="OnSort('GlobalId', $event.detail)" (widthChange)="onColumnWidthChange('GlobalId', $event)">
      <div class="header-cell-content">
        <span>Global ID</span>
      </div>
    </owc-table-header-cell>
    <owc-table-header-cell vertical-border="true" [verticalBorder]="true" resizable [width]="columnWidths['LocalId'] + 'px'" sortable [align]="'left'" (sortOrderChange)="OnSort('LocalId', $event.detail)" (widthChange)="onColumnWidthChange('LocalId', $event)">
      <div class="header-cell-content">
        <span>Local ID</span>
      </div>
    </owc-table-header-cell>
    <owc-table-header-cell vertical-border="true" [verticalBorder]="true" resizable [width]="columnWidths['Country'] + 'px'" sortable [align]="'left'" (sortOrderChange)="OnSort('Country', $event.detail)" (widthChange)="onColumnWidthChange('Country', $event)">
      <div class="header-cell-content">
        <span>Country</span>
      </div>
    </owc-table-header-cell>
    <owc-table-header-cell vertical-border="true" [verticalBorder]="true" resizable [width]="columnWidths['Title'] + 'px'" sortable [align]="'left'" (sortOrderChange)="OnSort('Title', $event.detail)" (widthChange)="onColumnWidthChange('Title', $event)">
      <div class="header-cell-content">
        <span>Title</span>
      </div>
    </owc-table-header-cell>
    <owc-table-header-cell vertical-border="true" [verticalBorder]="true" resizable [width]="columnWidths['CreationDate'] + 'px'" sortable [align]="'left'" (sortOrderChange)="OnSort('CreationDate', $event.detail)" (widthChange)="onColumnWidthChange('CreationDate', $event)">
      <div class="header-cell-content">
        <span>Date Created</span>
      </div>
    </owc-table-header-cell>
    <owc-table-header-cell vertical-border="true" [verticalBorder]="true" resizable [width]="columnWidths['NotificationOwner'] + 'px'" sortable [align]="'left'" (sortOrderChange)="OnSort('NotificationOwner', $event.detail)" (widthChange)="onColumnWidthChange('NotificationOwner', $event)">
      <div class="header-cell-content">
        <span>Notification Owner</span>
      </div>
    </owc-table-header-cell>
    <owc-table-header-cell vertical-border="true" [verticalBorder]="true" [width]="'minmax(' + columnMinWidths['Status'] + 'px, 1fr)'" sortable [align]="'left'" (sortOrderChange)="OnSort('Status', $event.detail)">
      <div class="header-cell-content">
        <span>Status</span>
      </div>
    </owc-table-header-cell>
   
  </owc-table-header>

  <owc-table-body>
    @if(paginatedData?.length > 0){
    @for (item of paginatedData; track $index) {
    <owc-table-row locked (click)="openNotificationDetails(item)">

      <owc-table-simple-cell vertical-border="true" [verticalBorder]="true" [title]="item.Type" style="cursor: pointer;">
        <div class="truncate-text">
          {{ item.Type }}
        </div>
      </owc-table-simple-cell>
      <owc-table-simple-cell vertical-border="true" [verticalBorder]="true" [title]="item.GlobalId" style="cursor: pointer;">
        <div class="truncate-text">
          {{ item.GlobalId }}
        </div>
      </owc-table-simple-cell>
      <owc-table-simple-cell vertical-border="true" [verticalBorder]="true" [title]="item.LocalId" style="cursor: pointer;">
        <div class="truncate-text">
          {{ item.LocalId }}
        </div>
      </owc-table-simple-cell>
      <owc-table-simple-cell vertical-border="true" [verticalBorder]="true" [title]="item.Country" style="cursor: pointer;">
        <div class="truncate-text">
          {{ item.Country }}
        </div>
      </owc-table-simple-cell>
      <owc-table-simple-cell vertical-border="true" [verticalBorder]="true" [title]="item.Title" style="cursor: pointer;">
        <div class="truncate-text">
          {{ item.Title }}
        </div>
      </owc-table-simple-cell>
      <owc-table-simple-cell vertical-border="true" [verticalBorder]="true" [title]="item.CreationDate" style="cursor: pointer;">
        <div class="truncate-text">
          {{ appUtils.formatDateOnly(item.CreationDate) }}
        </div>
      </owc-table-simple-cell>
      <owc-table-simple-cell
        vertical-border="true"
        [verticalBorder]="true"
        class="notification-owner-cell"
        tabindex="0"
        role="button"
        (click)="$event.preventDefault(); $event.stopPropagation(); editOwner(item, $event)"
        (keydown)="onOwnerCellKeydown(item, $event)">
        @if (isOwnerEditing(item)) {
        <owc-input
          #ownerInput
          class="notification-owner-editor"
          variant="outlined"
          rounded
          type="text"
          [placeholder]="'Enter Owner'"
          [value]="item.NotificationOwner || ''"
          (valueChange)="onOwnerValueChange(item, $event.detail)"
          (input)="onOwnerValueChange(item, $any($event.target).value)"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
          style="width: 100%;">
          <owc-icon
            slot="suffix"
            name="save"
            family="outlined"
            title="Save"
            style="cursor: pointer;"
            (click)="saveOwner(item, $event)">
          </owc-icon>
        </owc-input>
        } @else {
        <div
          class="notification-owner-display"
          [class.is-empty]="!item.NotificationOwner"
          tabindex="0"
          (click)="$event.preventDefault(); $event.stopPropagation(); editOwner(item, $event)"
          (keydown)="onOwnerCellKeydown(item, $event)">
          <span class="notification-owner-text" [title]="item.NotificationOwner || 'Enter Owner'">{{ getOwnerDisplayValue(item) }}</span>
          <owc-icon
            name="edit"
            family="outlined"
            title="Edit"
            style="cursor: pointer; flex-shrink: 0;"
            (click)="$event.preventDefault(); $event.stopPropagation(); editOwner(item, $event)">
          </owc-icon>
        </div>
        }
      </owc-table-simple-cell>
      <owc-table-simple-cell vertical-border="true" [verticalBorder]="true" class="status-cell" style="display: flex; align-items: center; cursor: pointer;">
        <owc-chip class="status-chip" [ngClass]="appUtils.getColor(item.Status)" [title]="item.Status">
          <img src="assets/{{notificationStatusIcon[item.Status]}}" class="chip-icon" style="cursor: pointer;">
          <span class="status-chip-text" style="margin-left: 4px; padding-right: 0px; text-align: left; cursor: pointer;">
            {{ item.Status }}
          </span>
        </owc-chip>

        <owc-icon name="chevron_right" family="outlined" class="status-chevron" style="cursor: pointer;"></owc-icon>
      </owc-table-simple-cell>

      

    </owc-table-row>
    }
    } @else if(totalCount === 0 || isApiLoading) {
      <owc-table-row>
        <owc-table-simple-cell [attr.colspan]="8">
          <div style="white-space: nowrap;padding: 20px;">
          @if(isApiLoading){
            <div style="margin-left: 480px;">Fetching data...</div>
          } @else if(isApiFailure){
            <div style="margin-left: 480px;">No data available.</div>
          } @else if(filterBool){
            <div style="margin-left: 400px;">No data available with given filter criteria.</div>
          } @else if(searchBool){
            <div style="margin-left: 400px;">No data available with given search criteria.</div>
          } @else {
            <div style="margin-left: 480px;">No data available.</div>
          }
          </div>
        </owc-table-simple-cell>
      </owc-table-row>
    }
  </owc-table-body>

  <owc-component-footer style="display: flex; padding: 0px; height: 10px; align-items: center; border: 1px solid #d3d3d3; background-color: #f5f5f2;">

    <div class="simple-pagination" *ngIf="totalCount > 0">
      <div class="pagination-left">
        <span class="items-per-page-label">Items per page:</span>
        <select 
          class="page-size-dropdown"
          [value]="pageSize" 
          (change)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [value]="size">
            {{ size }}
          </option>
        </select>
      </div>
      
      <div class="pagination-center">
        <span class="pagination-info">{{ startIndex }} &nbsp; - &nbsp; {{ endIndex }} &nbsp; of &nbsp; {{ totalCount }}</span>
      </div>
      
      <div class="pagination-right">
        <button 
          class="nav-button" 
          [disabled]="currentPage === 0"
          (click)="goToFirstPage()"
          title="First page">
          &#8810;
        </button>
        <button 
          class="nav-button" 
          [disabled]="currentPage === 0"
          (click)="goToPreviousPage()"
          title="Previous page">
          &#8249;
        </button>
        <button 
          class="nav-button" 
          [disabled]="currentPage >= totalPages - 1"
          (click)="goToNextPage()"
          title="Next page">
          &#8250;
        </button>
        <button 
          class="nav-button" 
          [disabled]="currentPage >= totalPages - 1"
          (click)="goToLastPage()"
          title="Last page">
          &#8811;
        </button>
      </div>
    </div>

    <owc-button variant="primary" class="button" (click)="openLocalNotificationDialog()">
      Create Local Notification
    </owc-button>

  </owc-component-footer>
  </owc-table>
  }
</div>